import * as React from "react";
import { forwardRef } from "react";
const LogoFacebookSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#364E8A" }),
    React.createElement("path", { fill: "#fff", d: "M13.09 18.667h-2.969v-6.638H8.667V9.72h1.454V8.335c0-1.847.849-3.002 3.212-3.002h2v2.31h-1.212c-.909 0-.97.346-.97.923V9.72h2.182l-.242 2.309h-2z" }));
const ForwardRef = forwardRef(LogoFacebookSVG);
export default ForwardRef;
//# sourceMappingURL=LogoFacebook.js.map